export default __webpack_public_path__ + "static/media/us_national_parks.d143bc64.png";